import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { handleChangeId } from "../../../utils/selectBoxFunc";

function PriceSelector({ items, priceId, setPriceId }) {
  return (
    <div className="selectConditions searchList isPriceCategory">
      <Select
        // NOTE: undefinedを渡すとreact-selectが直前の選択を保持し続けるため、未選択時はnullで選択を解除する
        value={items.find((obj) => obj.value === priceId) || null}
        options={items}
        onChange={(e) => handleChangeId(e, setPriceId)}
        placeholder=""
      />
    </div>
  );
}

PriceSelector.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  priceId: PropTypes.string,
  setPriceId: PropTypes.func.isRequired,
};

PriceSelector.defaultProps = {
  priceId: null,
};

export default PriceSelector;
